
var ClipboardHelper = {
    copyToClipboard: (text: string) => {
        var input = document.createElement("input");

        input.style.position = 'fixed';
        input.style.top = '0';
        input.style.left = '0';

        input.style.width = '100px';
        input.style.height = '10px';

        input.style.padding = '0';
        input.style.zIndex = '-100';

        input.value = text;

        document.body.appendChild(input);

        input.select();

        try {
            //Alert or something if successful?
            document.execCommand('copy');
        } catch (err) {
            //Notify if failed?
        }

        document.body.removeChild(input);
    }
}

export default ClipboardHelper;